import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import {
  useRefresh,
  useNotify,
  useMutation,
  Button,
  SimpleForm,
  useDataProvider,
} from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { useFormState } from "react-final-form";
import MuiButton from "@material-ui/core/Button";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
import SanitizedGrid from "../../../components/SanitizedGrid";
import InternalNoteInput from "components/InternalNoteInput";

interface IInternalNoteStudentButton {
  studentId: string;
}

const CustomConfirmButton = ({ studentId }: IInternalNoteStudentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const { values } = useFormState();

  const [handleUpdateNoteStudent, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `students/${studentId}/note`,
      payload: {
        data: {
          StudentId: Number(studentId),
          Note: values.internalNote?.value,
        },
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully update note student.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed update note the student, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleUpdateNoteStudent}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const InternalNoteStudentButton = ({
  studentId,
}: IInternalNoteStudentButton) => {
  const [student, setStudent] = useState<IStudent>();
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();
  const provider = useDataProvider();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getStudent = (studentId: number) => {
    provider.getOneAxios("students", { id: studentId }).then((data: any) => {
      setStudent(data.data);
    });
  };

  useEffect(() => {
    if (open) {
      getStudent(Number(studentId));
    }
  }, [open]);

  return (
    <Fragment>
      <MuiButton onClick={handleOpenDialog}>
        <SpeakerNotesIcon />
      </MuiButton>
      <SimpleForm toolbar={null}>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialog}
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            Internal Note Student
          </DialogTitle>
          <DialogContent>
            <SanitizedGrid container spacing={2}>
              <Grid item xs={12}>
                <InternalNoteInput record={student} />
              </Grid>
            </SanitizedGrid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" label="Back" />
            <CustomConfirmButton studentId={studentId} />
          </DialogActions>
        </Dialog>
      </SimpleForm>
    </Fragment>
  );
};

export default InternalNoteStudentButton;
